import Phaser from 'phaser';
import { generateFallbackTextures } from '../assets/ProceduralAssets';
import { TRAFFIC_ASSETS } from '../config/traffic';
import { VEHICLES } from '../config/vehicles';
import { EventBus, Events } from '../utils/EventBus';

export class PreloadScene extends Phaser.Scene {
  constructor() {
    super('PreloadScene');
  }

  preload(): void {
    for (const v of VEHICLES) {
      this.load.image(v.spriteKey, `/${v.spritePath}`);
      this.load.image(v.thumbnailKey, `/${v.thumbnailPath}`);
    }
    for (const t of TRAFFIC_ASSETS) {
      this.load.image(t.key, `/${t.path}`);
    }
    this.load.on('loaderror', (file: Phaser.Loader.File) => {
      console.warn('[Nganya] asset load failed:', file.key, file.url);
    });
  }

  create(): void {
    // Collectibles / scenery / missing vehicle or traffic fallbacks.
    generateFallbackTextures(this);

    for (const v of VEHICLES) {
      if (!this.textures.exists(v.spriteKey)) {
        generateFallbackTextures(this, v.id);
      }
    }

    EventBus.emit(Events.READY);
  }
}
